import { DefaultSlider } from "./styles/DefaultSlider";

export const sliderStyles = {
  default: {
    label: "Standard",
    Slider: DefaultSlider,
  },
};
